module.exports = __webpack_public_path__ + "static/img/2-2.a86dc76f.png";